@if (show) {
  <kendo-dialog (close)="onClose()">
    <kendo-dialog-titlebar class="text-primary">
      {{ 'HOME_COMPONENTS.INSTALL_DATE.PLANNED_INSTALL_DATE' | translate }}
    </kendo-dialog-titlebar>
    <div class="p-3">
      <div class="mb-3">
        <kendo-formfield>
          <kendo-label
            [for]="installdatepicker"
            id="dialogText"
            class="text-primary"
            >
            {{ 'HOME_COMPONENTS.INSTALL_DATE.PLANNED_INSTALL_DATE_LOWER' | translate }}
          </kendo-label>
          <kendo-datepicker
            [disabled]="remove"
            [min]="mindate"
            [(ngModel)]="installdate"
            #installdatepicker
            required
            >
          </kendo-datepicker>
          <kendo-formerror>{{ 'HOME_COMPONENTS.INSTALL_DATE.ERROR_REQUIRED' | translate }}</kendo-formerror>
        </kendo-formfield>
      </div>
      <div class="mb-3">
        <input type="checkbox" [(ngModel)]="remove" #notification kendoCheckBox />
        <kendo-label
          class="k-checkbox-label"
          [for]="notification"
          [text]="'HOME_COMPONENTS.INSTALL_DATE.REMOVE_PLANNED_INSTALL_DATE' | translate"
        ></kendo-label>
      </div>
      @if (errors?.length > 0) {
        <div >
          <div>{{ 'HOME_COMPONENTS.INSTALL_DATE.CONFLICT_FOUND' | translate }} ({{ errors.length }})</div>
          <kendo-grid
            class="error-grid"
            [kendoGridBinding]="errors"
            [autoSize]="false"
            >
            <kendo-grid-column
              [width]="50"
              field="message"
              [title]="'HOME_COMPONENTS.INSTALL_DATE.MESSAGE' | translate"
            ></kendo-grid-column>
          </kendo-grid>
        </div>
      }
    </div>
    <kendo-dialog-actions [layout]="'end'">
      <button kendoButton look="outline" [themeColor]="'base'" (click)="onClose()">
        <fa-icon [icon]="faTimes" class="w-px-20 me-1"></fa-icon>
        {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
      </button>
      <button
        kendoButton
        [themeColor]="'primary'"
        [disabled]="isExecuting || (installdate == null && !remove)"
        (click)="onSave()"
        >
        <fa-icon [icon]="faCheck" class="w-px-20 me-1"></fa-icon>
        {{ 'HOME_COMPONENTS.COMMON.SAVE' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
